export default __webpack_public_path__ + "static/media/logo.ad52122e.svg";